import '../styles/ActionButtons.scss';

import { CaretLeft, CaretRightIcon as CaretRight } from '@phosphor-icons/react';
import { Button } from '@whistler-ui/k2/components/Button';
import { Stack } from '@whistler-ui/k2/components/Stack';
import { useClassHelper } from '@whistler-ui/k2/hooks';

import { IMPLEMENTATION_FORM_EVENT_TYPES } from '../constants';
import { ActionButtonsPropsType } from '../types';

const componentName = 'c-ActionButtons';

export const ActionButtons = ({
  currentPageIndex,
  goBackward,
  disabledSaveButton,
  isLoading,
}: ActionButtonsPropsType) => {
  const c = useClassHelper(componentName);

  return (
    <section className={componentName}>
      <div className={c('__left')}>
        {currentPageIndex > 0 && (
          <Button
            onClick={goBackward}
            color="tertiary"
            disabled={isLoading}
            classes={{
              button: c('__button'),
            }}
          >
            <Stack direction="row" gap={1} align="center">
              <CaretLeft
                size={16}
                aria-label="go to previous page button icon"
              />
              <span>Previous</span>
            </Stack>
          </Button>
        )}
      </div>
      <div className={c('__right')}>
        <Button
          type="submit"
          aria-label="save button"
          data-event-type={IMPLEMENTATION_FORM_EVENT_TYPES.SAVE}
          disabled={Boolean(isLoading || disabledSaveButton)}
          color="ghost"
          classes={{
            button: c('__button'),
          }}
        >
          Save
        </Button>
        <Button
          type="submit"
          aria-label="save and continue button"
          data-event-type={IMPLEMENTATION_FORM_EVENT_TYPES.SAVE_AND_FORWARD}
          disabled={Boolean(isLoading || disabledSaveButton)}
          classes={{
            button: c('__button'),
          }}
        >
          <Stack direction="row" gap={1} align="center">
            <span>Save & Continue</span>
            <CaretRight aria-hidden size={16} />
          </Stack>
        </Button>
      </div>
    </section>
  );
};
